import script from "./PCImagenesEntidad.vue?vue&type=script&setup=true&lang=js"
export * from "./PCImagenesEntidad.vue?vue&type=script&setup=true&lang=js"

import "./PCImagenesEntidad.vue?vue&type=style&index=0&id=55e6c4b8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55e6c4b8"]])

export default __exports__